import { exams } from '../../../api/exams';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import React from "react";
import { useMutation, useQuery } from "react-query";
import { v4 } from "uuid";
import Loader from '../../../components/loader/Loader';
import Result from './components/Result';
import { useDispatch } from 'react-redux';
import { clearFlaggedQuestion } from '../../../features/candidate-exam/candidate-exam-slice';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const Results = () => {
  
  const {id} = useParams()
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const userExamId = searchParams.get('userExamId');
  const user = JSON.parse(sessionStorage.getItem('user'))
  const { data: results, isLoading } = useQuery(
    ["exam results"],
    async () => {
      const data = await exams.getExamResults({
          userId:  user?.user?.user_id  || sessionStorage.getItem('user_id'),
          examId:  id,
          userExamId
      });
      return data;
    },
    {
      select: (response) => response,
    },
  );

  const results_ = results || []

     const {isLoading: retakeLoading, mutateAsync} = useMutation(exams.retakeExam)
    const dispatch = useDispatch()
    const navigate = useNavigate();
  const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');
    const retakeExam = async (examId) => {
      if(!parseInt(sessionStorage.getItem('isAllowed'))){
        return toast.error(t('max-attempts-error'));
      }
      try {
        const response = await mutateAsync({examId, userId: sessionStorage.getItem('user_id')});
         if(response?.data?.redirect_to_results){
          return toast.error(t('max-attempts-error'));
          }       
          dispatch(clearFlaggedQuestion(null));
          sessionStorage.setItem("user_id", response?.data?.user?.user_id )
          window.sessionStorage.setItem("active-assessment-id", response?.data?.user?.exam_id);
          window.sessionStorage.setItem("active-assessment-user-id", response?.data?.user?.user_exam_id);
          window.sessionStorage.setItem("active-assessment", JSON.stringify(response?.data?.exam));
          window.sessionStorage.setItem("time_left", response?.data?.exam?.time_left);
          window.sessionStorage.setItem("duration", response?.data?.exam?.duration);
          window.sessionStorage.setItem("ql", response?.data?.exam?.number_of_questions);
          window.sessionStorage.setItem("starting-index", response?.data?.exam?.number_of_questions_answered);
        // navigate("/candidate/assessments/instructions");
        if(response?.data?.exam?.number_of_attempts) {
          sessionStorage.setItem('attempt_count', response?.data?.exam?.number_of_attempts)
        }  
        navigate(`/candidate/assessments/instructions`)
        sessionStorage.setItem('fromRoute', 'result')
      } catch (error) {
        toast.error(error?.response?.data?.message)
      }
    }
  

  if (isLoading) {
    return <Loader />;
  }


  return (
    <React.Fragment>
      <header className='bg-white sticky  top-0 flex justify-between items-center py-5 px-4 rounded-md mb-4'>
        {sessionStorage.getItem('activeExam') }
        {
          parseInt(sessionStorage.getItem('attempt_count')) <= 3 ?
              <button style={{ backgroundColor: brandedClient?.primary_colour || undefined}} className="text-white bg-primary hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              onClick={ () => retakeExam(id) }
                >
                   {retakeLoading ? t('loading') : t('retake-exam')} 
             </button>
          : null
        }
      </header>
      {/* <header className='bg-white flex justify-between items-center py-5 px-4 rounded-md mb-4'>
        <h1 className='text-lg'>
          Overall Results Status:
          <span
            className={`capitalize ml-2 text-${
              results?.overall_result_status && statusColor[results?.overall_result_status]}`
              }
            >
              {results?.overall_result_status}
            </span>
        </h1>
      </header> */}
      {/*USER DETAILS*/}
      {/* <UserDetails /> */}
      {/*RESULTS*/}
      {
        results_?.length ?
          [...results_]?.sort((a, b) => {
            const dateA = new Date(a?.result?.completed_at).getTime();
            const dateB = new Date(b?.result?.completed_at).getTime();
            return dateB - dateA; 
          })?.map((results, index) => {
            return (
              <section className='bg-white mb-5 p-3 md:p-8 rounded-md' key={v4()}>
                <Result 
                  key={v4()} 
                  results={results} 
                  isLoading={isLoading}
                  index={index}
                />
              </section>
            )
          })
        : null
      }
    </React.Fragment>
  );
};

export default Results;
